import { useEffect, useState } from "react";
import introJs from "intro.js";
import "intro.js/introjs.css";
import { useNavigate } from "react-router-dom";
import {earn_reward_points, sign_in, header_main, home_section_left, home_section_right, home_tab_one, upload_bill_icon,upload_receipt} from '../Image/Index'
import ModalCard from "../components/layout/ModalCard";

const IntroRewardPoints=()=>{


const intro=introJs()
let complete=false
let exitOnLast=false
const [show,setShow]=useState(false)
const navigate=useNavigate()
    useEffect(() => { 
      localStorage.setItem('firstLogin', 'customer')
        const handleLoad=()=>{ 
         const steps = [
            {
                element: document.getElementById('rewards'),
                title: 'Earn Reward Points ',
                intro: " Share your unique code and increase your loyalty points by referring friends and family. "
              },
              {
                element: document.getElementById('uploadbill'),
                title: 'Upload Bills  ',
                intro: " Share your unique code and increase your loyalty points by referring friends and family. "
              },
              {
                element: document.getElementById('overview'),
                title: 'Overview ',
                intro: " Get an overview of the ongoing special offers where you can earn rewards. "
              },
          
              
             
         ]
         intro.setOptions({
             steps: steps,
            exitOnOverlayClick: false,
             doneLabel:"Next",
             tooltipClass: 'customTooltip'
           });
         intro.start();
         } 
         setTimeout(()=>{
            handleLoad()
         },500)
         return () => {
            intro.exit();
        }; 
        
       }, []);
       intro.oncomplete(function(element) {
        complete=true
        setTimeout(()=>{
            if(!exitOnLast) navigate("/intro/customer/campin")
        },700)


    });
    intro.onexit(() => {
        if(!complete) {
            localStorage.setItem('firstLogin','')  
           setShow(true)
            }
            
        
      });
      intro.onchange(function(element) {
        switch (this._currentStep){
            case 0:
              setTimeout(()=>{
                let cross=  document.getElementsByClassName("introjs-skipbutton")[0]
                cross?.addEventListener('click', function() {
                exitOnLast=true
                localStorage.setItem('firstLogin','')   
                setShow(true)  
                });
              },600)  
      
              
                   break;
                 
           }
      
      });
    return(<>
    {show && <ModalCard show={show} customer={true}/>}

    <div className="cj_home_one">
      <div className="cj_home_one_header">
        <img src={header_main} alt=""/>
      </div>
      <div className="cj_home_one_body">
        <div className="cj_home_one_body_left">
          <img  src={home_section_left} alt=""/>
        </div>
        <div  id='rewards' className="cj_home_one_body_right">
          <img src={home_section_right} alt=""/>
        </div>
      </div>
      <div id='overview' className="cj_home_one_big_body">
        <img src={home_tab_one} alt=""/>
       
        <div id="uploadbill" className="upload_bill_button">
          <img src={upload_bill_icon}/>
        </div>
      </div>
      {/* <div className="cj_home_one_upload_receipt">
        <img src={upload_receipt}/>
      </div> */}
      </div>
    

    {/* <img src={earn_reward_points} style={{"height":'400px'}} ></img>
    <img id='rewards' src={earn_reward_points}></img> */}
    
    </>)
}
export default IntroRewardPoints